export { default } from './LottieAnimation';
